import { render, staticRenderFns } from "./CardClientOt.vue?vue&type=template&id=7dc1c44d&scoped=true"
import script from "./CardClientOt.vue?vue&type=script&lang=js"
export * from "./CardClientOt.vue?vue&type=script&lang=js"
import style0 from "./CardClientOt.vue?vue&type=style&index=0&id=7dc1c44d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc1c44d",
  null
  
)

export default component.exports